import { defineElement, html, TemplateElement, unsafeHTML } from '@webtides/element-js';
import '../../../../src/components/@e-banking/components/e-banking-icon-list/e-banking-icon-list.js';
import { mapNodes } from '@/mgnl/utils/magnolia.js';
import { getImageAttributes } from '@/services/content-service.js';

class EditableIconList extends TemplateElement {
    properties() {
        return {
            content: {},
        };
    }

    injectProperties() {
        return { environment: null };
    }

    get list() {
        const list = mapNodes(this.content.list) || [];
        return list.map((item) => ({ text: item.text, icon: getImageAttributes(this.environment, item.icon, 150) }));
    }

    template() {
        return html` <mb-e-banking-icon-list .headline="${this.content.headline}" .list="${this.list}"></mb-e-banking-icon-list> `;
    }
}

defineElement('editable-icon-list', EditableIconList);
